"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mobileMediaQueryOn = exports.mobileMediaQueryOff = exports.mobileMediaQueryVarName = exports.SITE_ST_CSS_PATH = exports.wixFontThemesName = exports.wixMediaUrlFormatterOriginalArgsParamname = exports.wixMediaUrlFormatter = exports.wixMediaUrlName = exports.THEME_FONT_KEY = exports.THEME_COLOR_KEY = exports.THEME_DATA = exports.CSS_HEADER_SITE_CSS = exports.CSS_HEADER_UPLOADED_FONTS = exports.METERING_HIST_RESPONSE_SIZE_MASTER_SUFFIX = exports.METERING_HIST_RESPONSE_SIZE = exports.METERING_COLLECT_FONTS = exports.METERING_PRE_PARSE = exports.METERING_FETCH = exports.METERING_TRANSFORM = exports.METERING_TOTAL = void 0;
exports.METERING_TOTAL = 'stylableTotal';
exports.METERING_TRANSFORM = 'transformStylable';
exports.METERING_FETCH = 'fetchingPages';
exports.METERING_PRE_PARSE = 'preParse';
exports.METERING_COLLECT_FONTS = 'collectFonts';
exports.METERING_HIST_RESPONSE_SIZE = 'responseSize';
exports.METERING_HIST_RESPONSE_SIZE_MASTER_SUFFIX = '_masterPage';
exports.CSS_HEADER_UPLOADED_FONTS = '\n/*uploaded fonts*/\n';
exports.CSS_HEADER_SITE_CSS = '\n/*site css*/\n';
exports.THEME_DATA = 'THEME_DATA';
exports.THEME_COLOR_KEY = 'color';
exports.THEME_FONT_KEY = 'font';
exports.wixMediaUrlName = 'wix-media-url';
exports.wixMediaUrlFormatter = 'wixMediaUrl';
exports.wixMediaUrlFormatterOriginalArgsParamname = 'formatterValues';
exports.wixFontThemesName = 'wix-font-themes';
exports.SITE_ST_CSS_PATH = '/site.st.css';
exports.mobileMediaQueryVarName = 'mobileMediaQuery';
exports.mobileMediaQueryOff = 'screen and (min-width: 1px) and (max-width: 0px)';
exports.mobileMediaQueryOn = 'screen and (min-width: 0px)';
//# sourceMappingURL=consts.js.map